<template>
  <div class="feature-image-wrapper" :class="{'odd-card': (idx + 2) % 2 === 0}">
    <img class="feature-image" :src="img" :alt="`feature_${idx + 1}`">
  </div>
</template>

<script>
export default {
	name: 'FeatureImage',
  props: {
		idx: {
      type: Number,
      required: false,
      default: 0
		},
    img: {
      type: String,
      required: false,
      default: ''
    },
	}
}
</script>

<style lang="scss" scoped>
.feature-image-wrapper {
	max-width: 1280px;
	width: 100%;
}
.feature-image {
	box-shadow: 0 0 10px 0 rgba(0,0,0,.1);
  // object-fit: cover;
  object-fit: contain;
}
.odd-card {
	text-align: right;
}
</style>


// WEBPACK FOOTER //
// src/components/LP/atoms/FeatureImage.vue